import { EMAIL_SETTINGS as emailSettings } from './emailSettings';
import { SUBSCRIPTION_SETTINGS as subscriptionSettings } from './subscriptionSettings';
import { USER_ACCOUNT_SETTINGS as userAccountSettings } from './userAccountSettings';

export const USER = {
  emailSettings,
  userAccountSettings,
  subscriptionSettings
};
